<template>
  <div v-if="statuses!=null">
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th>ردیف</th>
          <th>کدپروژه</th>
          <th>عنوان</th>
          <th>نام مشتری</th>
          <th>موبایل</th>
          <th>مدیرپروژه</th>
          <th>بازدیدکننده</th>
          <th>عکس</th>
          <th>فایل</th>
          <th>گزارش</th>
          <th>وضعیت</th>
        </tr>
      </thead>
      <tbody name="fruit-table">
        <tr v-for="(project , index) in data" :key="project.id">
          <td>{{index+1}}</td>
          <td>
            <router-link class="btn btn-outline-primary" v-if="can('projects.show')"
              :to="{
                name:'projects.show',
                params: { id: project.id}
                }">
              {{project.code}}
            </router-link>
            <p v-else>{{project.code}}</p>
          </td>
          <td>
            {{project.name}}
          </td>
          <td v-text="project.customer.name"></td>
          <td v-text="project.customer.mobile"></td>
          <td>
            <button class="btn btn-default" v-if="project.managerBtn" @click="project.managerBtn = !project.managerBtn">{{project.manager.name}}</button>
            <select class="form-control" @change="changeManager($event.target.value, project.id)" v-else>
                <option value="">مدیرپروژه</option>
                <option v-for="(user, index) in managers" :key="index" :value="user.id" :selected="project.manager_id===user.id">{{user.name}}</option>
            </select>
          </td>
          <td>
            <button class="btn btn-default" v-if="project.visitorBtn" @click="project.visitorBtn = !project.visitorBtn">{{project.visitor.name}}</button>
            <select class="form-control" @change="changeVisitor($event.target.value, project.id)" v-else>
              <option value="">بازدیدکننده</option>
              <option v-for="(user, index) in visitors" :key="index" :value="user.id" :selected="project.visitor_id===user.id">{{user.name}}</option>
            </select>
          </td>
          <td>
            <button class="btn btn-secondary btn-floating ml-2" type="button" data-toggle="modal" :data-target="'#projectUploadPhoto' + project.id">{{project.images_count}}</button>
            <div class="modal fade" :id="'projectUploadPhoto' + project.id" tabindex="-1" role="dialog" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" :id="'projectUploadPhotoTitle' + project.id">آپلود عکس</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="بستن">
                      <em class="ti-close"></em>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="form-row d-flex justify-content-center">
                      <div class="d-flex flex-column">
                        <div class="align-self-start mx-5">انتخاب دسته بندی عکس:</div>
                      </div>
                      <select class="align-self-center form-control mb-3 mx-5" v-model="state">
                        <option value="" selected>دسته بندی را انتخاب کنید</option>
                        <option value="0">رندر</option>
                        <option value="1">بازرسی</option>
                        <option value="2">برداشت</option>
                      </select>
                      <input type="file" class="align-self-center form-control mx-5" ref="file" @change="submit($event, project.id)" multiple="multiple" v-if="state!=''" required>
                    </div>
                    <div class="progress m-b-20 mt-5" v-if="progress > 0 && progress < 100">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="{ width: progress + '%'}" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100">
                        </div>
                      </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">بستن</button>
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td><button class="btn btn-info btn-floating ml-2" type="button">{{project.files_count}}</button></td>
          <td><button class="btn btn-success btn-floating ml-2" type="button">{{project.daily_reports_count}}</button></td>
          <td>
            <button class="btn btn-default text-white" :style="{ backgroundColor: statuses[project.status].color }" v-if="project.statusBtn" @click="project.statusBtn = !project.statusBtn">{{statuses[project.status].name}}</button>
            <select class="form-control text-white" :style="{ backgroundColor: statuses[project.status].color }" @change="changeStatus($event.target.value, project.id)" v-else>
              <option v-for="(status, index) in statuses" :key="index" :value="index" :selected="project.status===index">{{status.name}}</option>
            </select>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th>ردیف</th>
          <th>کدپروژه</th>
          <th>عنوان</th>
          <th>نام مشتری</th>
          <th>موبایل</th>
          <th>مدیرپروژه</th>
          <th>بازدیدکننده</th>
          <th>عکس</th>
          <th>فایل</th>
          <th>گزارش</th>
          <th>وضعیت</th>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ProjectComponent',
  props: ['data', 'statuses', 'managers', 'visitors'],
  data () {
    return {
      users: null,
      categories: ['رندر', 'بازرسی', 'برداشت'],
      state: '',
      progress: 0,
      projectId: null,
      count: null
    }
  },
  watch: {
    progress: function (val) {
      if (val === 100) {
        const num = this.data.findIndex(staff => staff.id === this.projectId)
        this.data[num].images_count = this.data[num].images_count + this.count
        window.$('#projectUploadPhoto' + this.projectId).modal('hide')
        this.progress = 0
        this.projectId = null
        this.count = null
        // eslint-disable-next-line no-undef
        swal(
          'تبریک!',
          'فایل ها با موفقیت آپلود شدند!',
          'success'
          , {
            button: 'باشه'
          })
      }
    }
  },
  methods: {
    submit (event, projectId) {
      this.projectId = projectId
      this.progress = 0
      const images = event.target.files || event.dataTransfer.files
      const count = images.length
      this.count = count
      for (var i = 0; i < count; i++) {
        const formData = new FormData()
        const file = images[i]
        formData.append('file', file)
        this.$send.submit('post', 'api/project/' + projectId + '/upload/image/' + this.state, formData)
          .then(response => {
            this.progress += 100 / count
          })
      }
    },
    changeManager (managerId, projectId) {
      this.$send.submit('post', 'api/project/manager/' + managerId + '/' + projectId)
        .then(response => {
          const num = this.data.findIndex(x => x.id === projectId)
          this.data[num].manager_id = managerId
        })
    },
    changeVisitor (visitorId, projectId) {
      this.$send.submit('post', 'api/project/visitor/' + visitorId + '/' + projectId)
        .then(response => {
          const num = this.data.findIndex(x => x.id === projectId)
          this.data[num].visitor_id = visitorId
        })
    },
    changeStatus (status, projectId) {
      const that = this
      this.$send.submit('post', 'api/project/status/' + status + '/' + projectId)
        .then(response => {
          const num = this.data.findIndex(x => x.id === projectId)
          this.data[num].status = status
          that.openNotification(
            'top-center',
            'success',
            '100%',
            'تغییروضعیت پروژه:',
            'تغییروضعیت پروژه باموقیت انجام شد!'
          )
        })
    },
    openNotification (position = null, color, width = '100%', title, message) {
      this.$vs.notification({
        duration: 'none',
        width,
        color,
        position,
        title: title,
        text: message
      })
    }
  }
}
</script>

<style>
.red{
  color:red;
}
</style>
